import { AppliedPolicyStatusType } from '@/react/portainer/environments/types';

import { SearchBar } from '@@/datatables/SearchBar';
import {
  StatusSummaryBar,
  StatusSegment,
} from '@@/StatusSummaryBar/StatusSummaryBar';

import { PolicyStatusBreakdown } from '../../types';

interface Props {
  statusBreakdown?: PolicyStatusBreakdown;
  statusFilter?: AppliedPolicyStatusType;
  onStatusFilterChange(value?: AppliedPolicyStatusType): void;
  isLoading?: boolean;
  search?: string;
  onSearchChange?(value: string): void;
}

export function PolicyStatusBar({
  statusBreakdown,
  statusFilter,
  onStatusFilterChange,
  isLoading,
  search = '',
  onSearchChange,
}: Props) {
  const total = statusBreakdown
    ? statusBreakdown.Applied +
      statusBreakdown.Warning +
      statusBreakdown.Failed +
      statusBreakdown.InProgress +
      statusBreakdown.NotSupported
    : 0;

  const segments: StatusSegment<AppliedPolicyStatusType>[] = [
    {
      key: AppliedPolicyStatusType.Applied,
      label: 'Active',
      count: statusBreakdown?.Applied ?? 0,
      color: 'success',
    },
    {
      key: AppliedPolicyStatusType.Warning,
      label: 'Warning',
      count: statusBreakdown?.Warning ?? 0,
      color: 'warning',
    },
    {
      key: AppliedPolicyStatusType.Failed,
      label: 'Failed',
      count: statusBreakdown?.Failed ?? 0,
      color: 'error',
    },
    {
      key: AppliedPolicyStatusType.InProgress,
      label: 'In progress',
      count: statusBreakdown?.InProgress ?? 0,
      color: 'blue',
    },
    {
      key: AppliedPolicyStatusType.NotSupported,
      label: 'Not supported',
      count: statusBreakdown?.NotSupported ?? 0,
      color: 'gray',
    },
  ];

  return (
    <div className="mb-4" data-cy="policy-status-bar">
      <StatusSummaryBar
        total={total}
        segments={segments}
        value={statusFilter ?? null}
        onChange={(value) => onStatusFilterChange(value ?? undefined)}
        isLoading={isLoading}
        radioGroupName="policy-status-filter"
        ariaLabel="Filter by policy status"
        data-cy="policy-status-summary-bar"
        rightSlot={
          onSearchChange ? (
            <SearchBar
              value={search}
              onChange={onSearchChange}
              data-cy="policy-attachments-search"
            />
          ) : undefined
        }
      />
    </div>
  );
}
